export default __webpack_public_path__ + "static/media/avatar.0a984838.png";